export default __webpack_public_path__ + "assets/czech-republic-flag.png";